<template>
  <div class="custom-checkbox" :class="[checkboxType, checkboxView]">
    <input :id="checkboxId" type="checkbox" name="" />
    <label :for="checkboxId"></label>
  </div>
</template>

<script>
  export default {
    name: 'CustomCheckbox',

    props: {
      checkboxType: String,
      checkboxId: String,
      checkboxView: String
    }
  };
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  .custom-checkbox {
    width: 20px;
    height: 20px;
    margin-right: 10px;
    display: flex;
    position: relative;
  }

  .square label {
    border-radius: 3px;
  }

  .square label:after {
    top: 6px;
    width: 9px;
    height: 5px;
    border: 2px solid #333;
    border-top: none;
    border-right: none;
  }

  .square input[type='checkbox']:checked + label:after {
    opacity: 1;
    border-bottom-color: #fff;
    border-left-color: #fff;
  }

  .circle label {
    border-radius: 10px;
  }

  .circle label:after {
    top: 5px;
    width: 8px;
    height: 8px;
    border-radius: 20px;
  }

  .circle input[type='checkbox']:checked + label {
    opacity: 1;
    background-color: #fff;
  }

  .reverse input[type='checkbox']:checked + label:after {
    top: 3px;
    left: 3px;
    width: 12px;
    height: 12px;
    background-color: $green !important;
  }

  .reverse input[type='checkbox']:checked + label {
    opacity: 1;
    background-color: #fff !important;
    border-color: $green !important;
  }

  .custom-checkbox input {
    display: none;
  }

  .custom-checkbox label {
    cursor: pointer;
    position: absolute;
    width: 20px;
    height: 20px;
    top: 0;
    left: 0;
    background: #fff;
    border: 1px solid #b5b5b5;
    transition: all 0.3s;
  }

  .custom-checkbox label:after {
    opacity: 0;
    content: '';
    position: absolute;
    background: transparent;
    left: 5px;
    transition: all 0.3s;
    transform: rotate(-45deg);
  }

  .custom-checkbox label:hover::after {
    opacity: 0.5;
  }

  .custom-checkbox input[type='checkbox']:checked + label:after {
    opacity: 1;
    border-bottom-color: #fff;
    border-left-color: #fff;
  }

  .custom-checkbox input[type='checkbox']:checked + label {
    opacity: 1;
    background-color: $green;
  }
</style>
